import { CardElement } from '@stripe/react-stripe-js';
import { useTheme } from '@mui/material/styles';
import MuiInputLabel, {
  InputLabelProps as MuiInputLabelProps,
} from '@mui/material/InputLabel';

function Label({ children, ...props }: MuiInputLabelProps) {
  return (
    <MuiInputLabel shrink sx={{ lineHeight: 1 }} {...props}>
      {children}
    </MuiInputLabel>
  );
}

export default function StripeCardField({ disabled, label, isCardCompleted }) {
  const theme = useTheme();
  const style = {
    base: {
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
      fontSize: '16px',
      lineHeight: '23px',
      '::placeholder': { color: theme.palette.grey[400] },
    },
    complete: { color: theme.palette.success.main },
    invalid: {
      iconColor: theme.palette.error.main,
      color: theme.palette.error.main,
    },
  };

  const handleChangeCard = async (event) => {
    // Listen for changes in the CardElement
    isCardCompleted(event.complete);
  };

  return (
    <>
      <div className={disabled ? 'StripeContainer--disabled' : null}>
        <Label htmlFor="card-element">{label}</Label>
        <CardElement
          id="card-element"
          options={{ disabled, style }}
          onChange={handleChangeCard}
        />
      </div>
    </>
  );
}
